export default __webpack_public_path__ + "static/media/release-notes.b88a3e7b.svg";